import { ClientConfigProductName } from '@frontend/vanilla/core';

export const TabbedGridLoader = {
    id: 'tabbed-grid',
    loaderFn: () => import(/* webpackChunkName: "ms-tabbed-grid-widget" */ './tabbed-grid.feature'),
    product: ClientConfigProductName.SPORTS,
};
